// internal imports
import { Image } from "./hero-image.styles";

const HeroImage = () => {
  return <Image src="/assets/images/hero-image.svg" alt="shaifq" />;
};

export default HeroImage;
